import { render, staticRenderFns } from "./PracticeItem.vue?vue&type=template&id=18c6cb9c&scoped=true"
import script from "./PracticeItem.vue?vue&type=script&lang=js"
export * from "./PracticeItem.vue?vue&type=script&lang=js"
import style0 from "./PracticeItem.vue?vue&type=style&index=0&id=18c6cb9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c6cb9c",
  null
  
)

export default component.exports